// Creates DOM element to be used as React root
var createRootElement = function createRootElement(id) {
  var rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};

export { createRootElement };